var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRankWidgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.838 193.6H67.4115C63.0381 193.6 59.4115 189.974 59.4115 185.6V130.987C59.4115 119.894 68.478 110.827 79.5713 110.827H107.838C112.211 110.827 115.838 114.453 115.838 118.827V185.493C115.838 189.973 112.211 193.6 107.838 193.6ZM75.4115 177.6H99.8379V126.934H79.5713C77.3313 126.934 75.4115 128.746 75.4115 131.093V177.6V177.6Z",
    fill: "#6B456A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.161 193.6H107.734C103.361 193.6 99.7344 189.974 99.7344 185.6V82.5599C99.7344 71.4666 108.801 62.3997 119.894 62.3997H136.108C147.201 62.3997 156.268 71.4666 156.268 82.5599V185.6C156.161 189.974 152.641 193.6 148.161 193.6ZM115.841 177.6H140.268V82.5599C140.268 80.3199 138.454 78.3997 136.108 78.3997H119.894C117.654 78.3997 115.734 80.2132 115.734 82.5599V177.6H115.841Z",
    fill: "#6B456A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.588 193.6H148.161C143.788 193.6 140.161 189.974 140.161 185.6V137.066C140.161 132.693 143.788 129.066 148.161 129.066H176.428C187.521 129.066 196.588 138.133 196.588 149.227V185.6C196.588 189.974 193.068 193.6 188.588 193.6ZM156.161 177.6H180.588V149.227C180.588 146.987 178.775 145.066 176.428 145.066H156.161V177.6V177.6Z",
    fill: "#6B456A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160 242.667H96C38.08 242.667 13.3333 217.92 13.3333 160V96C13.3333 38.08 38.08 13.3333 96 13.3333H160C217.92 13.3333 242.667 38.08 242.667 96V160C242.667 217.92 217.92 242.667 160 242.667ZM96 29.3333C46.8267 29.3333 29.3333 46.8267 29.3333 96V160C29.3333 209.173 46.8267 226.667 96 226.667H160C209.173 226.667 226.667 209.173 226.667 160V96C226.667 46.8267 209.173 29.3333 160 29.3333H96Z",
    fill: "#6B456A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankWidgetIcon);
export default __webpack_public_path__ + "static/media/rankWidgetIcon.cbd2f3470b97f7ceb55a5dcafcee3818.svg";
export { ForwardRef as ReactComponent };